import React from 'react';

const LogoutIcon = () => {
    return (
        <svg data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M17 22H4V2h13v3h2V1a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v22a1 1 0 0 0 1 1h15a1 1 0 0 0 1-1v-4h-2z"/><path d="M23.71 12.71l-4.24 4.24-1.41-1.41L20.59 13H5.76v-2h14.83l-2.54-2.54 1.41-1.41 4.24 4.24a1 1 0 0 1 .01 1.42z"/></svg>    )
};

export default LogoutIcon;